module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1g.6dfe114e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-1g.mp3
// module id = 507
// module chunks = 0